// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsDashboard\ReservationsDashboardViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { ReservationsDashboardRow, ReservationsDashboardRowData, ReservationsDashboardRowOptions } from 'data/models/ReservationsDashboardRow';
import { PortCallUserRole } from 'server/enums/PortCallUserRole';

// ReservationsDashboardResponseData is the class that ReservationsDashboardResponse serializes to/from
export interface ReservationsDashboardResponseData {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    Role : PortCallUserRole;
    ToDate : /* ISO8601 */ string;
	
    Organization : OrganizationData | null;
    Rows : ReservationsDashboardRowData[] | null;
	
}

// ReservationsDashboardResponseOptions is the class which may be passed to the ReservationsDashboardResponse constructor to define optional initial data values
export interface ReservationsDashboardResponseOptions {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    Role : PortCallUserRole;
    ToDate : /* ISO8601 */ string;
	
    Organization? : OrganizationOptions | null;
    Rows? : ReservationsDashboardRowOptions[] | null;
	
}

export class ReservationsDashboardResponse {
    public FromDate : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
    public Role : DataSignal<PortCallUserRole>;
    public ToDate : DataSignal<TZDate>;
	
    public Organization : DataSignal<Organization | null>;
    public Rows : SDataArray<ReservationsDashboardRow>;
	

    constructor();
    constructor(data : ReservationsDashboardResponseOptions);
    constructor(data: ReservationsDashboardResponseOptions | null = null) {
        this.FromDate = jsonableObservable(S.value<TZDate>(data && data.FromDate !== undefined ? new TZDate(data.FromDate) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Role = jsonableObservable(S.value<PortCallUserRole>(data && data.Role !== undefined ? data.Role : 0));
        this.ToDate = jsonableObservable(S.value<TZDate>(data && data.ToDate !== undefined ? new TZDate(data.ToDate) : new TZDate(0), TZDate.eq));
	    
        this.Organization = S.value<Organization | null>(null);
        this.Rows = SArray<ReservationsDashboardRow>([]);
	    
    }

    static key(obj : ReservationsDashboardResponse) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.Role() + '\u2618' + obj.ToDate().toJSON();
    }
    
    static dataKey(obj : ReservationsDashboardResponseOptions) {
        return new TZDate(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.Role + '\u2618' + new TZDate(obj.ToDate).toJSON();
    }

    static update(obj : ReservationsDashboardResponse, data : ReservationsDashboardResponseOptions) {
        S.freeze(() => {
            if (data.FromDate !== undefined) obj.FromDate(new TZDate(data.FromDate));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.Role !== undefined) obj.Role(data.Role);
            if (data.ToDate !== undefined) obj.ToDate(new TZDate(data.ToDate));
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ReservationsDashboardResponse.ts